import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 定义路由
// 每个路由应该映射一个组件。 其中"component"是一个组件配置对象。
const routes = [
  // 聊天
  {
    path: '/chat',
    name: 'chat',
    component (resolve) {
      require(['../pages/Chat'], resolve)
    }
  },
  {
    path: '/cdetail',
    name: 'cdetail',
    component (resolve) {
      require(['../pages/CDetail'], resolve)
    }
  },
]

let router = new VueRouter({
  history: true,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js